import Echo from 'laravel-echo'
import Pusher from 'pusher-js'
import { DateTime } from 'luxon'

export default defineNuxtPlugin(() => {
  const userStore = useUserStore()
  const websocketStore = useWebsocketStore()
  const chatStore = useChatStore()
  const runtimeConfig = useRuntimeConfig()
  const tenantId = runtimeConfig.public.PFLEGERING_TENANT_ID
  const defaultEchoBody = {
    broadcaster: 'pusher',
    key: 'pgdox3h7rm74luaxhzqx',
    cluster: 'eu',
    wsHost: 'ws.1tool.com',
    wsPort: 443,
    wssPort: 443,
    forceTLS: true,
    enabledTransports: ['ws', 'wss']
  }

  watch(
    () => chatStore.channels,
    (newChannels) => {
      if (newChannels?.length) {
        newChannels.forEach((channel) => createChatMessageChannel(channel.id))
      }
    }
  )

  watch(
    () => [userStore.isLoggedInAsContact, userStore.isLoggedIn],
    ([isLoggedInAsContact, isLoggedIn]) => {
      if (true && (isLoggedInAsContact || isLoggedIn)) {
        window.Pusher = Pusher

        if (isLoggedInAsContact) {
          window.Echo = new Echo({
            ...defaultEchoBody,
            authEndpoint: 'https://my.1tool.com/suite/broadcasting/auth/contact',
            bearerToken: userStore.contact.token,
            auth: {
              headers: {
                Accept: 'application/json',
                'X-Tenant': tenantId
              }
            }
          })
        } else if (isLoggedIn) {
          window.Echo = new Echo({
            ...defaultEchoBody,
            authEndpoint: 'https://my.1tool.com/suite/broadcasting/auth',
            bearerToken: userStore.user.api_token
          })
        }

        window.Echo.connector.pusher.connection.bind('connected', () => {
          const socketId = window.Echo.socketId()
          websocketStore.setSocketId(socketId)
        })
      }
    },
    { immediate: true }
  )

  watch(
    () => userStore.currentId,
    (newValue) => {
      if (newValue) createNewChannel()
    },
    { immediate: true }
  )

  function createChatMessageChannel(channelId) {
    window.Echo.private(`chat.${tenantId}.${channelId}`).listen('.NewMessage', async (event) => {
      const existingChannel = chatStore.findExistingChannelById(event.message.channel_id)
      const isFromCurrentUserOrContact = userStore.isLoggedInAsContact
        ? userStore.contact?.id === event.message.contact_id
        : userStore.user?.id === event.message.user_id

      const translatedMessage = (await chatStore.translateMessages([event.message]))[0]
      if (
        chatStore.selectedChannel &&
        chatStore.selectedChannel.id === translatedMessage.channel_id
      ) {
        if (!isFromCurrentUserOrContact) {
          chatStore.setUsernameForMessage(translatedMessage.channel_id, translatedMessage)
          chatStore.messages.push(translatedMessage)
          chatStore.scrollToBottom()
        }
        useApi(`${chatStore.chatEndpoint}/participant-status`, 'PUT', {
          channel_id: chatStore.selectedChannel.id,
          read_up_to: DateTime.now().toFormat('yyyy-MM-dd HH:mm:ss'),
          ...(userStore.isLoggedInAsContact
            ? { contact_id: userStore.contact.id }
            : { user_id: userStore.user.id })
        })
      } else if (!isFromCurrentUserOrContact) {
        const currentMessages = chatStore.unreadMessages.get(translatedMessage.channel_id) || []
        chatStore.unreadMessages.set(translatedMessage.channel_id, [
          ...currentMessages,
          translatedMessage
        ])
      }
      existingChannel.messages.unshift(translatedMessage)
      chatStore.moveChannelToTop(translatedMessage.channel_id)
    })
  }

  function createNewChannel() {
    window.Echo.private(`${chatStore.contactOrUser}.${userStore.currentId}`).listen(
      '.NewChannel',
      async (event) => {
        if (!chatStore.findExistingChannelById(event.channelId)) {
          const channelResponse = await useApi(
            `${chatStore.chatEndpoint}/channels/${event.channelId}`,
            'GET'
          )
          channelResponse.data.messages = []
          chatStore.channels = [channelResponse.data, ...chatStore.channels]
          chatStore.unreadMessages.set(event.channelId, chatStore.channels.messages)
          chatStore.loadInitialOrMissingParticipantsByChannel(chatStore.channels)
        }
      }
    )
  }
})
